import './synapra-footer.css';

/** Assinatura da plataforma, distinta da marca do restaurante. */
export default function SynapraFooter() {
  return (
    <footer className="synapra-footer" translate="no">
      <span>made by</span>
      <img src="/branding/synapra-symbol.png" alt="" width={19} height={24} />
      <strong>Synapra</strong>
    </footer>
  );
}
